import React from 'react';

import moment from 'moment';

import { Button, Modal } from '@shared/components/bootstrap';

export type OrphanShiftCutoffUser = {
  user_id: number;
  user_name: string;
};

type DispatcherOrphanShiftDialogProps = {
  users: OrphanShiftCutoffUser[];
  workDateLabel: string;
  resolving?: boolean;
  onKeep: () => void;
  onRemoveShifts: () => void;
};

export const DispatcherOrphanShiftDialog: React.FC<DispatcherOrphanShiftDialogProps> = ({
  users,
  workDateLabel,
  resolving = false,
  onKeep,
  onRemoveShifts,
}) => (
  <Modal onClose={onKeep}>
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>Field shifts still scheduled</Modal.Title>
        <Modal.Close close={onKeep} />
      </Modal.Header>
      <Modal.Body>
        <p>
          After the cutoff, removing someone from every route can leave a field shift on the roster with no dispatch
          assignment.
        </p>
        <div className="dialog-orphan-shift-block">
          <p className="dialog-orphan-shift-lead">
            The following employees have no routes on <strong>{workDateLabel}</strong> but still have a shift:
          </p>
          <ul className="dialog-orphan-shift-names">
            {users.map((user) => (
              <li key={user.user_id}>
                <strong>{user.user_name}</strong>
              </li>
            ))}
          </ul>
        </div>
        <div className="dialog-orphan-shift-hints">
          <div className="dialog-orphan-shift-hint">
            <span className="dialog-orphan-shift-hint-label">Remove field shifts</span>
            <span className="dialog-orphan-shift-hint-text">
              Removes the field shift for <strong>{workDateLabel}</strong>.
            </span>
          </div>
          <div className="dialog-orphan-shift-hint">
            <span className="dialog-orphan-shift-hint-label">Keep shifts</span>
            <span className="dialog-orphan-shift-hint-text">
              Leaves the shift in place if you will assign another route.
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="default" size="lg" type="button" onClick={onKeep} disabled={resolving}>
          Keep shifts
        </Button>
        <Button kind="danger" size="lg" type="button" onClick={onRemoveShifts} disabled={resolving} loading={resolving}>
          Remove field shifts
        </Button>
      </Modal.Footer>
    </Modal.Content>
  </Modal>
);

export const formatDispatcherWorkDateLabel = (date: string) => moment(date).format('MMMM D, YYYY');
